export default defineNuxtPlugin(async () => {
  if ('serviceWorker' in navigator) {
    const registration = await navigator.serviceWorker.ready

    // Function to check online status and trigger sync
    const checkAndSync = () => {
      if (registration.active) {
        // Check online status
        registration.active.postMessage({ action: 'check-online-status' })

        // For iOS Safari, periodically check if we need to retry
        const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent)
        if (isIOS) {
          console.log('iOS detected, enabling periodic sync check')
          // Check every 30 seconds if online
          setInterval(() => {
            if (navigator.onLine) {
              registration?.active?.postMessage({ action: 'check-online-status' })
            }
          }, 30000)
        }
      }
    }

    // Initial check
    checkAndSync()

    // Listen for online/offline events
    window.addEventListener('online', () => {
      console.log('App is online, triggering sync')
      if (registration.active) {
        console.log('Sync check', registration)
        // Try to trigger background sync
        if ('sync' in registration) {
          // Use the correct sync tag that Workbox expects
          registration.sync
            .register('workbox-background-sync:api-requests-queue')
            .then(() => {
              console.log('Background sync registered successfully')
            })
            .catch((err) => {
              console.log('Background sync registration failed:', err)
              // Fallback to message
              registration.active?.postMessage({ action: 'check-online-status' })
            })
        } else {
          // iOS Safari fallback
          ;(registration as any).active.postMessage({ action: 'check-online-status' })
        }
      }
    })

    window.addEventListener('offline', () => {
      console.log('App is offline')
    })

    // Check when app comes to foreground (visibility change)
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden && navigator.onLine) {
        console.log('App visible and online, checking for queued requests')
        checkAndSync()
      }
    })

    // Periodic check for queue status (for debugging)
    if (import.meta.env.DEV) {
      setInterval(() => {
        const channel = new MessageChannel()
        channel.port1.onmessage = (event) => {
          if (event.data.queueSize > 0) {
            console.log(`[Debug] Queue size: ${event.data.queueSize}`)
          }
        }
        registration.active?.postMessage({ action: 'get-queue-status' }, [channel.port2])
      }, 10000)
    }
  }
})
